import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import * as moment from 'moment';
import { Sec002SecagemItemComponent } from 'src/app/shared/sec002-secagem-item/sec002-secagem-item.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-sec002-card-II',
    templateUrl: './sec002-card-II.component.html'
})

export class Sec002CardIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    public listOptionsRessecagem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsMotvEspDebulha?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listOptionNivelamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public filterOptionsRessecagem: Observable<DropDownListDTO[]>;
    public filterOptionsMotvEspDebulha: Observable<DropDownListDTO[]>;

    @Input() dateErrors: Function;
    @Output() isRessect = new EventEmitter();
    public isReadonly: boolean = true

    public pesoTotalRW: number;

    public disabledBtnRemove: boolean = true;
    public listOpetkOption?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    @Output() mkCalc = new EventEmitter();
    @Output() mkCalcDate = new EventEmitter();
    @Output() mkCalcPrebasica = new EventEmitter();

    @ViewChild("viewContainerRef", { read: ViewContainerRef })
    VCR: ViewContainerRef;


    @Input() geracao: any;

    child_unique_key: number = -1;

    secagemItemReferences = Array<ComponentRef<Sec002SecagemItemComponent>>()

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService,
        protected formBuilder: FormBuilder,
        protected notificationService: NotificationService,
        protected generalService: GeneralService,
        private CFR: ComponentFactoryResolver,) {
        super('Secagem', false);
        if (this.isBasica || this.isComercial)
            this.formulario = this.formBuilder.group({
                Inicio_secagem_data: [null, [Validators.pattern(this.regexDate)]],
                Inicio_secagem_hora: [null, [Validators.pattern(this.regexHour)]],
                Inversao_camara_data: [null, [Validators.pattern(this.regexDate)]],
                Inversao_camara_hora: [null, [Validators.pattern(this.regexHour)]],
                optek_amostra: ['', []],
                umidade_amostra: ['', [Validators.min(8), Validators.max(20)]],
                hora_amostragem: ['', []],
                data_amostragem: ['', []],
                Termino_secagem_data: [null, [Validators.pattern(this.regexDate)]],
                Termino_secagem_hora: [null, [Validators.pattern(this.regexHour)]],
                Umidade_media_fechamento_av: [null, []],
                Umidade_topo_de_fechamento_moff: [null, []],
                Ressecagem: [null, []],
                Altura_camada_m: [null, [Validators.max(4.50)]],
                avaliacao_nivelamento: [null, []],
                observacao_nivelamento: [null, []],
                Inicio_ressecagem_data: [null, [Validators.pattern(this.regexDate)]],
                Inicio_ressecagem_hora: [null, [Validators.pattern(this.regexHour)]],
                Termino_ressecagem_data: [null, [Validators.pattern(this.regexDate)]],
                Termino_ressecagem_hora: [null, [Validators.pattern(this.regexHour)]],
            });
        else if (this.isPreBasica)
            this.formulario = this.formBuilder.group({
                amostragem_data: ['', [Validators.pattern(this.regexDate)]],
                amostragem_hora: ['', [Validators.pattern(this.regexHour)]],
                amostra_1_umidade: [null, []],
                amostra_2_umidade: [null, []],
                amostra_3_umidade: [null, []],
                umidade_media: [null, []],
                andar_secador: [null, []],
                numero_secador: [null, []],
                numero_dumper: [null, []],
                secagem_frio: [null, []],
                finalizou_secagem_caixa: [null, []],
                Ressecagem: [null, []],
                peso_pos_secagem: [null, []],
                rendimento_pos_secagem: [null, []]
            });
    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();
        await this.getFilters();
        await this.getListOptek();
        await this.getListNivelamento();
        this.checkRessecagem();
        this.formulario.get('Ressecagem')?.valueChanges.subscribe(value => {
            this.changeRessecagemField();
        });

        const ressecagemControl = this.formulario.get('Ressecagem');

        ressecagemControl?.valueChanges.subscribe((value) => {
            if (value === '') {
                localStorage.removeItem('Ressect');
            }
        });
    }

    alertaData() {
        const inicioSecagemData = moment(this.formulario.get('Inicio_secagem_data')?.value as string, 'DD/MM/YYYY hh:mm:ss');
        const terminoSecagemData = moment(this.formulario.get('Termino_secagem_data')?.value as string, 'DD/MM/YYYY hh:mm:ss');
        const inicioSecagemHora = this.formulario.get('Inicio_secagem_hora').value;
        const terminoSecagemHora = this.formulario.get('Termino_secagem_hora').value;

        const [hourInicio, minuteInicio] = inicioSecagemHora.split(":") //[10, 30] -> separa os elementos em um array
        const [hourTermino, minuteTermino] = terminoSecagemHora.split(":") //[10, 30] -> separa os elementos em um array

        const dataHoraInicioSecagem = inicioSecagemData.set({ hour: Number(hourInicio), minute: Number(minuteInicio) }).add(300, 'hours');
        const dataHoraTerminoSecagem = terminoSecagemData.set({ hour: Number(hourTermino), minute: Number(minuteTermino) });

        const dateDif = dataHoraInicioSecagem.diff(dataHoraTerminoSecagem);

        if (dateDif < 0) {
            this.formulario.get('Termino_secagem_hora').setErrors({ invalidTerminoSecagem: true })
        } else {
            this.formulario.get('Termino_secagem_hora').setErrors(null);
        }
    }

    callErrorFunction() {
        if (this.dateErrors) {
            this.dateErrors();
        }
    }


    blockField() {
        const getValue = this.formulario.get('avaliacao_nivelamento')?.value;
    
        if (getValue && getValue.includes('NÃO SATISFATÓRIO')) {
            this.formulario.get('observacao_nivelamento')?.setValidators([Validators.required]);
        } else {
            this.formulario.get('observacao_nivelamento')?.clearValidators();
        }
        this.formulario.get('observacao_nivelamento')?.updateValueAndValidity();
    }


    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async getLists(): Promise<void> {
        await this.getListOptionRessecagem();
    }

    async getFilters(): Promise<void> {
        await this.createFilterRessecagem();
    }

    async getListOptek(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'optek_amostra').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listOpetkOption = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        })
    }

    async getListNivelamento(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'avaliacao_nivelamento').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listOptionNivelamento = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        })
    }

    private async getListOptionRessecagem(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'ressecagem').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsRessecagem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async createFilterRessecagem(): Promise<void> {
        this.filterOptionsRessecagem = this.formulario.get('Ressecagem').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listOptionsRessecagem, value))
            );
    }


    changeRessecagemField() {
        const ressecagemControl = this.formulario.get('Ressecagem');

        if (ressecagemControl?.value === 'NÃO') {
            this.isReadonly = false;
        } else {
            this.isReadonly = true;
        }
    }



    checkRessecagem() {
        let isRessect: boolean = this.formulario.get('Ressecagem').value === "SIM"
        this.isRessect.emit(isRessect);
    }

    addItem() {
        this.disabledBtnRemove = false;

        this.createSecagemItemComponent();
    }

    public createSecagemItemComponent() {
        let componentFactory = this.CFR.resolveComponentFactory(Sec002SecagemItemComponent);
        let childComponentRef = this.VCR.createComponent(componentFactory);
        childComponentRef.instance.mkCalc.subscribe(val => {
            const amostra1Umidade = childComponentRef.instance.formulario?.get("amostra_1_umidade").value
            const amostra2Umidade = childComponentRef.instance.formulario?.get("amostra_2_umidade").value
            const amostra3Umidade = childComponentRef.instance.formulario?.get("amostra_3_umidade").value
            if (amostra1Umidade && amostra2Umidade && amostra3Umidade) {
                childComponentRef.instance.formulario?.get("umidade_media").setValue((amostra1Umidade + amostra2Umidade + amostra3Umidade) / 3);
            }
            else {
                childComponentRef.instance.formulario?.get("umidade_media").setValue((amostra1Umidade + amostra2Umidade) / 2);
            }

            if (childComponentRef.instance.formulario?.get("umidade_media").value <= 12.5)
                childComponentRef.instance.formulario?.get("finalizou_secagem_caixa").setValue("Sim");
            else
                childComponentRef.instance.formulario?.get("finalizou_secagem_caixa").setValue("Não");
            this.mkCalcPrebasica.emit();
            this.calcTemposAtividades();
        });
        childComponentRef.instance.calcDates.subscribe(val => {
            this.calcTemposAtividades();
        });
        childComponentRef.instance.componentsReferences = this.secagemItemReferences;
        let childComponent = childComponentRef.instance;
        childComponent.unique_key = ++this.child_unique_key;
        childComponent.parentRef = this;
        this.secagemItemReferences.push(childComponentRef);
    }



    calcTemposAtividades() {
        var sumHoursSecagem = 0;
        var sumHoursReSecagem = 0;
        this.secagemItemReferences.forEach(element => {
            var hourInit = this.generalService.createDateTimeData(element.instance.formulario?.get('amostragem_data_inicio').value, element.instance.formulario?.get('amostragem_hora_inicio').value);
            var hourEnd = this.generalService.createDateTimeData(element.instance.formulario?.get('amostragem_data_fim').value, element.instance.formulario?.get('amostragem_hora_fim').value);

            if (element.instance.formulario?.get('finalizou_secagem_caixa').value === "Sim") {
                sumHoursSecagem += hourEnd - hourInit;
            }
            if (element.instance.formulario?.get('Ressecagem').value === "SIM") {
                sumHoursReSecagem += hourEnd - hourInit;
            }
        });

        this.mkCalcDate.emit({ sumHoursSecagem, sumHoursReSecagem });
    }

    public async removeItem(): Promise<void> {
        if (!!this.secagemItemReferences) {
            this.secagemItemReferences[this.secagemItemReferences.length - 1].instance.remove(true);
            if (this.secagemItemReferences.filter(x => x.instance.btnExcluir == false).length == 0) {
                this.disabledBtnRemove = true
            }

        }
    }

    public removeSecagemItemComponent(key: number, lastItem = false) {
        this.VCR.remove(lastItem ? this.VCR.length - 1 : key);
        this.secagemItemReferences = this.secagemItemReferences.filter(
            x => x.instance.unique_key !== key)
        this.secagemItemReferences.forEach((x, index) => {
            x.instance.unique_key = index
        })
        --this.child_unique_key;
    }
}
